import { render, staticRenderFns } from "./HeroesTable.vue?vue&type=template&id=132599c0&"
import script from "./HeroesTable.vue?vue&type=script&lang=js&"
export * from "./HeroesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports